import { Box, Text } from '@factorialco/deprecated-design-system'
import { MessagesPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

const Messages = () => {
  const { company } = useCurrentSession()

  const { loading, data } = useQuery(MessagesPageDocument)

  if (loading) return <Loading />

  if (!data?.compensations?._policies?.compensationActivityManage?.can) {
    return <NotFound />
  }

  return (
    <Box padding="s24">
      <Text.Normal>
        {i18n.t('bookkeepers.clients.payroll_cycles.messages.write_message', {
          company: company.name,
        })}
      </Text.Normal>
    </Box>
  )
}

export default Messages
